module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": "",
      "lg4": "",
      "offset-lg4": ""
    }
  }, [_c('v-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.busy),
      expression: "busy"
    }],
    staticClass: "text-xs-center",
    staticStyle: {
      "position": "absolute",
      "z-index": "2",
      "background-color": "rgba(255,255,255,.95)",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "row": "",
      "fill-height": ""
    }
  }, [_c('v-flex', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }), _vm._v(" "), _c('div', [_c('h1', {
    staticClass: "headline mt-4 mt-4",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Loading, please wait...")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "text-xs-center",
    staticStyle: {
      "position": "absolute",
      "z-index": "2",
      "background-color": "rgba(255,255,255,1)",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "row": "",
      "fill-height": ""
    }
  }, [_c('v-flex', [_c('div', {
    staticClass: "px-3"
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "color": "error",
      "icon": "warning"
    }
  }, [_vm._v(_vm._s(_vm.error))])], 1)])], 1)], 1), _vm._v(" "), _c('h1', {
    staticClass: "headline pt-4 pb-4",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Pay invoice")]), _vm._v(" "), _c('h3', {
    staticClass: "title pt-1 pb-1",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.invoice.trip_name))]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "column": ""
    }
  }, [_c('v-flex', [_c('div', {
    staticStyle: {
      "min-width": "250px",
      "margin-bottom": "20px"
    }
  }, [_c('div', [_vm._v("Invoice no: " + _vm._s(_vm.invoice.fortnox_invoice_no) + " ")]), _vm._v(" "), _c('div', [_vm._v("Booking no: " + _vm._s(_vm.invoice.booking_id) + " ")]), _vm._v(" "), (_vm.invoice.paid_amount > 0) ? _c('div', [_c('div', [_vm._v("Total amount: " + _vm._s(_vm.invoice.amount_total) + " " + _vm._s(_vm.invoice.currency))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Remaining balance: " + _vm._s((_vm.invoice.amount_total - _vm.invoice.paid_amount).toFixed(2)) + " " + _vm._s(_vm.invoice.currency))])]) : _c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Total amount: " + _vm._s(_vm.invoice.amount_total) + " " + _vm._s(_vm.invoice.currency))])]), _vm._v(" "), (_vm.invoice.paid_amount > 0) ? _c('div', [_c('v-btn', {
    staticClass: "mr-0 ml-0",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.start_payment(0)
      }
    }
  }, [_vm._v("Pay remaining amount")])], 1) : (_vm.invoice.deposit_allowed > 0) ? _c('div', [_c('v-btn', {
    staticClass: "mr-0 ml-0",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.start_payment(0)
      }
    }
  }, [_vm._v("Pay full amount")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0 ml-0",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.start_payment(1)
      }
    }
  }, [_vm._v("Pay deposit (20%)")])], 1) : _c('div', [_c('v-btn', {
    staticClass: "mr-0 ml-0",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.start_payment(0)
      }
    }
  }, [_vm._v("Pay")])], 1)])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8064b32","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/booking/pay.vue
// module id = Z56H
// module chunks = 1